import axios from "axios";
import { updateAlert } from "../store/alert/actions";
import { updateLoading } from "../store/loading/actions";
import { getErrorCodeFromResultCode, getErrorMessage } from "../utils/enums";

// resultCode eşleşen MS kodu yoksa PRM'den MS0035 (genel sistem hatası) alınır, o da yoksa bu sabit kullanılır
const GENERIC_ERROR_MESSAGE = "Sistemsel bir hata oluşmuştur.";

// resultCode -1 ise errorText'i, 1239 gibi maplenen kodlarda PRM mesajını, diğerlerinde genel hata mesajını gösterir
function handleResultCodeError(data: any, dispatch: Function) {
  let message: string | undefined;
  if (String(data.resultCode) === "-1") {
    message = data.message;
  } else {
    const errorCode = getErrorCodeFromResultCode(data.resultCode);
    message = errorCode ? getErrorMessage(errorCode) : undefined;
  }
  message = message || getErrorMessage("MS0035") || GENERIC_ERROR_MESSAGE;

  dispatch(
    updateAlert({
      severity: "error",
      text: message,
      open: true,
    })
  );
  return { data: { ...data, result: "0", errorExplanation: message } };
}

const services = {
  getPrmData: {
    url: "GetPrmData", //"INSTANTCreditService/GetPrmData",
    props: [],
  },
  getCustAutoCompleteInfo: {
    url: "corporateStoreServices/getCustAutoCompleteInfo",
    props: [],
  },
  applicantCompany: {
    url: "signIn",
    props: [],
  },
  fibaPasswordCheckWithAuth: {
    url: "fibaPasswordCheckWithAuth",
    props: [],
  },
  productInfo: {
    url: "corporateStoreServices/productInfo",
    props: [],
  },
  getByUUID: {
    url: "getByUUID",
    props: [],
  },
  getSimulation: {
    url: "corporateStoreServices/simulation",
    props: [],
  },
  getInsuranceOffer: {
    url: "corporateStoreServices/insuranceOffer",
    props: [],
  },
  getInterestRate: {
    url: "corporateStoreServices/getInterestRate",
    props: [],
  },
  generateDocument: {
    url: "corporateStoreServices/generateDocument",
    props: [],
  },
  used: {
    url: "corporateStoreServices/used",
    props: [],
  },
  saveDocuments: {
    url: "corporateStoreServices/saveDocuments",
    props: [],
  },
  fibaPasswordCheck: {
    url: "corporateStoreServices/fibaPasswordCheck",
    props: [],
  },
  fibaKeyInfo: {
    url: "corporateStoreServices/fibaKeyInfo",
    props: [],
  },
  generateOTP: {
    url: "corporateStoreServices/generateOTP",
    props: [],
  },
  generateOTPApplicant: {
    url: "corporateStoreServices/generateOTPApplicant",
    props: [],
  },
  generateOtpEasycep: {
    url: "corporateStoreServices/generateOtpEasycep",
    props: [],
  },
  validateOTP: {
    url: "corporateStoreServices/validateOTP",
    props: [],
  },
  commissionPackOffer: {
    url: "corporateStoreServices/commissionPackOffer",
    props: [],
  },
  getCustLimitInfo: {
    url: "corporateStoreServices/getCustLimitInfo",
    props: [],
  },
};
type ObjectKey = keyof typeof services;

/*export const checkServiceProps = (serviceName, body) => {
  if (services[serviceName]) {
    services[serviceName].props.forEach((propName) => {
      if (body[propName] === undefined) {
        return false;
      }
    });
    return true;
  }
};*/

export const getServiceUrl = (serviceName: string) => {
  if (services[serviceName as ObjectKey]) {
    return services[serviceName as ObjectKey].url;
  }
};

export async function callServiceWithCredentials(
  serviceName: string,
  body: object,
  dispatch: Function,
  externalId: string
) {
  dispatch(updateLoading(true));
  return await axios
    .post(
      (window as any).ENV.CONFIG_BASE_URL + getServiceUrl(serviceName),
      { ...body, sessionId: window.sessionStorage.getItem("sessionId") || "" },
      { withCredentials: true, headers: { externalId } }
    )
    .then((response) => {
      // resultCode nonzero or result zero indicates a service failure.
      if (
        (response.data?.resultCode && response.data.resultCode !== "0") ||
        response.data?.result === 0 ||
        response.data?.result === "0"
      ) {
        if (response.data.resultCode === "1213") {
          throw new Error(response.data.errorText);
        }

        return handleResultCodeError(response.data, dispatch);
      }
      return response;
    })
    .catch((err) => {
      const errorMessage = err.message ? err.message : err;
      dispatch(
        updateAlert({
          severity: "error",
          text: errorMessage,
          open: true,
        })
      );
      return { data: { errorExplanation: errorMessage } };
    })
    .finally(() => {
      dispatch(updateLoading(false));
    });
}

export async function callService(
  serviceName: string,
  body: object,
  dispatch: Function,
  externalId: string
) {
  dispatch(updateLoading(true));
  return await axios
    .post(
      (window as any).ENV.CONFIG_BASE_URL + getServiceUrl(serviceName),
      { ...body, sessionId: window.sessionStorage.getItem("sessionId") || "" },
      { withCredentials: true, headers: { externalId } }
    )
    .then((response) => {
      if (
        serviceName === "used" &&
        response.data?.errorCode === "4007763" &&
        (response.data.result === "0" || response.data.result === 0)
      ) {
        return response;
      }
      // resultCode nonzero or result zero indicates a service failure.
      if (
        (response.data?.resultCode && response.data.resultCode !== "0") ||
        response.data?.result === 0 ||
        response.data?.result === "0"
      ) {
        // 1213 özel durum kontrolü
        if (response.data.resultCode === "1213") {
          throw new Error(response.data.errorText);
        }

        return handleResultCodeError(response.data, dispatch);
      }
      return response;
    })
    .catch((err) => {
      if (err.code === "ERR_BAD_REQUEST") {
        window.open("/unauthorized", "_self");
        window.close();
      }

      const errorMessage = err.message ? err.message : err;
      dispatch(
        updateAlert({
          severity: "error",
          text: errorMessage,
          open: true,
        })
      );
      if (serviceName === "used") {
        dispatch(updateLoading(false));
      }
      return { data: { errorExplanation: errorMessage } };
    })
    .finally(() => {
      if (serviceName !== "used") {
        dispatch(updateLoading(false));
      }
    });
}

export async function callServiceWithAuth(
  serviceName: string,
  body: object,
  dispatch: Function,
  externalId: string,
  username: string,
  password: string
) {
  dispatch(updateLoading(true));
  return await axios
    .post(
      (window as any).ENV.CONFIG_BASE_URL + getServiceUrl(serviceName),
      { ...body, sessionId: window.sessionStorage.getItem("sessionId") || "" },
      {
        withCredentials: true,
        headers: { externalId },
        auth: { username: username, password: password },
      }
    )
    .then((response) => {
      // resultCode nonzero or result zero indicates a service failure.
      if (
        (response.data?.resultCode && response.data.resultCode !== "0") ||
        response.data?.result === 0 ||
        response.data?.result === "0"
      ) {
        // 1213 özel durum kontrolü
        if (response.data.resultCode === "1213") {
          throw new Error(response.data.errorText);
        }

        return handleResultCodeError(response.data, dispatch);
      }
      return response;
    })
    .catch((err) => {
      if (err.code === "ERR_BAD_REQUEST") {
        window.open("/unauthorized", "_self");
        window.close();
      }

      const errorMessage = err.message ? err.message : err;
      dispatch(
        updateAlert({
          severity: "error",
          text: errorMessage,
          open: true,
        })
      );
      return { data: { errorExplanation: errorMessage } };
    })
    .finally(() => {
      dispatch(updateLoading(false));
    });
}
